import type { ReactNode } from 'react';
import React from 'react';

import { PageContainer } from 'src/shared/components/Layout/PageContainer';
import { NavigationLayout } from 'src/shared/layouts/AuthenticatedLayout/AuthenticatedLayoutWithNavigation';
import { Provider as ToastProvider } from 'src/shared/providers/Toaster';

import { Main } from './Main';
import { SkipLink } from './SkipLink';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <NavigationLayout>
    <PageContainer>
      <SkipLink />
      <Main>
        <ToastProvider>{children}</ToastProvider>
      </Main>
    </PageContainer>
  </NavigationLayout>
);

export { Layout };
